import { render } from "./SearchResult.vue?vue&type=template&id=25725a52&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=ts"
export * from "./SearchResult.vue?vue&type=script&lang=ts"

import "./SearchResult.vue?vue&type=style&index=0&id=25725a52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-25725a52"

export default script